<template>
  <div>
    <!--卡片布局-->
    <el-card shadow="always">
      <!--操作栏-->
      <div class="search-items">
        <div>
          <!-- <el-input size="small" v-model="queryInfo.queryStr" placeholder="请输入项目名进行查询" clearable @clear="loadData()">
            <el-button size="small" slot="append" icon="el-icon-search" @click="loadData()"></el-button>
          </el-input> -->
        </div>
        <!-- <div>
          <el-button size="small" type="primary" @click="handleAdd()">提交</el-button>
        </div> -->
      </div>
      <!--表格-->
      <el-table :data="tableData" stripe border style="width: 100%" :cell-style="cellStyle" :span-method="handleCourseSpan" >
        <!-- <el-table-column type="selection" width="50">
        </el-table-column> -->
        <!-- <el-table-column prop="cno" width="120" label="课程编号">
        </el-table-column> -->
        <el-table-column type="index" width="40">
        </el-table-column>
        <el-table-column prop="cname" :width="width140" label="课程名称">
          <template slot-scope="scope">
             <div @click="handleCourseDetail(scope.$index, scope.row)" style="color:#59a6ff;cursor: pointer">
                <el-button type="text" size="mini" icon="el-icon-thumb"></el-button>
                {{scope.row.cname}}
            </div>            
            <!-- <el-button type="text" @click="handleCourseDetail(scope.$index, scope.row)" icon="el-icon-thumb"> {{scope.row.cname}}
            </el-button> -->
          </template>
        </el-table-column>
        <el-table-column prop="pname" :width="width140"  label="项目名称" >
          <!-- <template slot-scope="scope">
             <div @click="handleProjectDetail(scope.$index, scope.row)" style="color:#59a6ff;cursor: pointer">
                <el-button type="text" size="mini" icon="el-icon-thumb"></el-button>
                {{scope.row.pname}}
            </div>           
          </template> -->
        </el-table-column>
        <el-table-column prop="pintroduction" label="项目简介" >
          <template slot-scope="scope">
             <div @click="handleProjectDetail(scope.$index, scope.row)" style="color:#59a6ff;cursor: pointer">
                <el-button type="text" size="mini" icon="el-icon-thumb"></el-button>
                {{scope.row.pintroduction}}
            </div>            
            <!-- <el-button type="text" @click="handleProjectDetail(scope.$index, scope.row)" icon="el-icon-thumb"> {{scope.row.pname}}
            </el-button> -->
          </template>
        </el-table-column>        
        <el-table-column prop="tnames" :width="width140" label="项目负责人">
        </el-table-column>
        <el-table-column prop="limitNum" :width="width80" label="剩余可选人数">
        </el-table-column>
        <el-table-column :width="width100" label="审核状态">
          <template slot-scope="scope">
            <template v-if="scope.row.status=='1'">
              <p style="color:#df1834">已审核</p>
            </template>
            <template v-else>
              <p style="color:#60d58f">未审核</p>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="截止时间" :width="width140">
            <template slot-scope="scope">{{timeFormate(scope.row.deadline)}}</template>
        </el-table-column>
        <el-table-column label="操作" :width="width100" v-if="opCloumnFlag" align="center">
          <template slot-scope="scope">
            <el-switch :width="switchWidth" @change="handleSelectCourse(scope.$index, scope.row)" :active-value="1" :inactive-value="0" :disabled="disabledSelect(scope.row)"
                       v-model="scope.row.userCourse">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.currentPage" :page-sizes="[1,5,10,100,1000]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <!-- <el-dialog title="课程信息" :visible.sync="cDetailFlag" @close="closeDialog">
      <course-form v-if="cDetailFlag" :is-edit='true' :cno='queryCno' :readFlag='true'></course-form>
    </el-dialog>
    <el-dialog title="项目信息" :visible.sync="pDetailFlag" @close="closeDialog">
      <project-form v-if="pDetailFlag" :is-edit='true' :pno='queryPno' :readFlag='true'></project-form>
    </el-dialog> -->

    <el-dialog title="课程信息" :visible.sync="cDetailFlag" @close="closeDialog">
      <div v-html='cImageText'>      
      </div>
    </el-dialog>
    <el-dialog title="项目信息" :visible.sync="pDetailFlag" @close="closeDialog">
      <div v-html='pImageText'>      
      </div>
    </el-dialog>    
  </div>
</template>

<script>
import { mapState } from "vuex"
import { selectProjectTaskListByAccount,updateProjectTask} from '@/api/projectTask'
import { updateStudentProjectAfterSelection } from '@/api/studentProject'
// import ProjectForm from '@views/project/projectForm'
// import CourseForm from '@views/course/courseForm'
import { selectProjectByNo } from '@/api/project'
import { selectCourseByNo } from '@/api/course'
export default {
  inject: ['reload'],
  name: "courseSelection",
  // components: { ProjectForm, CourseForm },
  data() {
    return {
      width140:"150px",
      width100:"100px",
      width80:"80px",
      formLabelWidth: '120px',
      selectNos: [],
      tableData: [],       //分页查询所有数据
      queryInfo: {        
        currentPage: 1,
        pageSize: 100
      },
      total: 0,
      file: null,
      allTableData: [],     //表格所有数据
      multipleSelection: [],
      rowSpanArr: [],
      userSelectCourse: ['aa', 'dd'],
      switchWidth: "80px",
      cDetailFlag: false,
      queryCno: '',
      pDetailFlag: false,
      queryPno: '',
      account:localStorage.getItem('account'),
      cImageText:'',
      pImageText:''
    }
  },
  created() {
    this.loadData();//分页条件获取所有学生信息
  },

  computed: {
     ...mapState({      
      userRoles: ({ user }) => user.roles,
    }),   
    //时间
    timeFormate() {
      return function (time) {  
        return moment(time).format('yyyy-MM-DD HH:mm')
      }
    },    
    disabledSelect() {
      return function (item) {
        if( moment().isAfter(moment(item.deadline))){
          return true
        }
        if (item.status == 1) {
          return true
        } else {
          return false
        }
      }
    },
    //只有学生角色才有操作列
    opCloumnFlag(){
      if(this.userRoles && _.includes(this.userRoles,'student')){
        return true
      }else{
        return false
      }
    }
  },
  methods: {
    /**
     * 合并课程项
     */
    handleCourseSpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.rowSpanArr[rowIndex];
        return {
          rowspan: _row, //行
          colspan: 1 //列
        };
      }

    },
    /**
     * 合并单元格
     */
    updateRowSpan(rowDatas) {
      this.rowSpanArr = [];
      let position = 0
      rowDatas.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          position = 0;
        } else {
          if (rowDatas[index].cname == rowDatas[index - 1].cname) {
            this.rowSpanArr[position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            rowDatas[index].cname = rowDatas[index - 1].cname;
          } else {
            this.rowSpanArr.push(1);
            position = index;
          }
        }
      });
    },
    //加载列表数据
    loadData() {
      //分页条件获取所有学生信息     
      let params = {
        account:this.account,
        currentPage: this.queryInfo.currentPage,
        pageSize: this.queryInfo.pageSize
      }
      selectProjectTaskListByAccount(params).then(response => {
        let rowDatas = response.data.data.entries;
         _.forEach(rowDatas, (obj) => {
           let selectSnoArr = obj.selectSnos?_.split(obj.selectSnos, ','):[]
           obj['selectSnoArr'] = selectSnoArr
           obj['limitNum'] = obj.peopleCapacity -selectSnoArr.length
           obj['userCourse'] =_.includes(selectSnoArr, this.account)?1:0
        })

        this.updateRowSpan(rowDatas)
        this.tableData = rowDatas
        this.total = response.data.data.total//response.data.data.total;
      });
    },
    /**
     * 触发选中课程
     */
    handleSelectCourse(index, row) {
      if (row.userCourse === 0) {
        row.limitNum += 1
        _.pull(row.selectSnoArr,this.account)
        this.submitSelectAction(row)
      }else if(row.limitNum == 0){
          row.userCourse = 0
          this.$message({
            message: '当前课程项目已无剩余可选！',
            type: 'warning',
            duration: 1000
          });        
      }
      else if (row.limitNum > 0 && row.userCourse === 1) {
        let selectObjs = _.filter(this.tableData, function (o) {
          return (o.cname === row['cname'] && o.userCourse === 1);
        })
        if (selectObjs.length > 1) {
          row.userCourse = 0
          this.$message({
            message: '当前课程项目只能选择一个项目,请先去掉其它项目勾选！',
            type: 'warning',
            duration: 1000
          });
        } else {
          row.limitNum -= 1
          row.selectSnoArr.push(this.account)
          this.submitSelectAction(row)
        }
      }
    },
    /**
     * 提交选择项
     */
    submitSelectAction(rowData){
      rowData.selectSnos = _.join(rowData.selectSnoArr, ',')
      updateStudentProjectAfterSelection(rowData,this.account).then(response => {
            this.$message({
            message: '操作成功！',
            type: 'success',
            duration: 2000
          });
         this.loadData();
      }).catch((err)=>{
        this.loadData();
      })      
    },
    handleCourseDetail(index, row) {
      selectCourseByNo(row['cno']).then(response => {
            let formObj = response.data.data      
            this.cDetailFlag = true
            this.cImageText = formObj.imageText
      })
      // this.queryCno = row['cno']
    },
    handleProjectDetail(index, row) {
      selectProjectByNo(row['pno']).then(response => {
            let formObj = response.data.data      
            this.pDetailFlag = true
            this.pImageText = formObj.imageText
      })      
      // this.queryPno = row['pno']
    },
    closeDialog() {
      this.cDetailFlag = false
      this.pDetailFlag = false
    },
    handleSizeChange(val) {
      //监听pageSize
      this.queryInfo.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      //监听currentPage
      this.queryInfo.currentPage = val;
      this.loadData();
    },
    getAllProject() {
      //用于excel的导出
      this.common.getAllData(this, this.apiUrl.selectAllProjects);
    },
    // cellStyle({row, column, rowIndex, columnIndex}){
    //   if(row)
    // }
  }
}
</script>

